import React, { useState } from 'react';
import { Pagination } from '@mui/material';
import { useNavigate } from "react-router-dom";
import AuthService from '../../Components/auth/AuthService';
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { Table, Button, Input, Flex, Modal, Card, Row, Col, Space } from 'antd/es';
import { DeleteFilled, EditFilled, FilterOutlined, PlusCircleFilled, SearchOutlined } from '@ant-design/icons';
import { showMessage } from '../../Components/Utils/message';
import { encodeId } from '../../Components/common/CommonFun';
import { styled } from '@mui/system';

const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();

export default function HelperList() {

  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();

  const [helpers, setHelpers] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const [limit] = React.useState(50);

  const deleteHelper = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/helper/warehouse-helper`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getHelperData();
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const helperColumns = [
    {
      title: 'Pin',
      dataIndex: 'pin',
      key: 'pin',
      width: 70,
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      width: 115,
      // sorter: true,
      // render(record: any) {
      //   return <Capitalize>{record}</Capitalize>;
      // },
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      width: 115,
      // sorter: true,
      // render(record: any) {
      //   return <Capitalize>{record}</Capitalize>;
      // },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 250,
    },

    {
      title: 'Daily Wage',
      render: (record) => {
        return record?.daily_wage
          ? "£" +
          Number(record?.daily_wage).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
          : '';
      },
      width: 100,

    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes',
      width: 300,
    },
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      width: '80px',
      render(record) {
        return (
          <Flex justify='end' onClick={(e) => e.stopPropagation()}>
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#006cb8" }} />
            <DeleteFilled
              onClick={() => {
                Modal.confirm({
                  title: 'Delete Helper',
                  centered: true,
                  content: `Are you sure you want to delete this helper?`,
                  onOk: () => deleteHelper(record.id),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
              style={{ fontSize: '25px', cursor: "pointer", color: "#cd1437" }} />
          </Flex>
        );
      },
    },
  ];

  const getHelperData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      limit: limit,
        page: page,
    }
    if(searchText) dataToSend.searchText = searchText?.trim()
    try {
      const res = await Auth.post(`/helper/warehouse-helpers`, dataToSend)
      if (res.ack) {
        setHelpers(res.warehouse_helpers);
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res.total_count);
      } else {
        showMessage('error', res.message);
        setHelpers([]);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong while fetching helpers');
    } finally {
      hideLoading(layoutDispatch);
    }
  }


  React.useEffect(() => {
    getHelperData();
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleRowClick = (id) => {
    const hasedID = encodeId(id)
    navigate(`/helpers/${hasedID}`)
  }


  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff' }} /> Helpers</>}
              style={{ marginBottom: '10px' }}
              extra={
                <>
        <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF" }} onClick={() => navigate("/helpers/new")} />
                </>
              }
            >
              <Row gutter={[6, 1]}>
                <Col xs={24} md={12} lg={6} xl={5}>
                  <Input
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value)
                      setPage(1)
                    }
                      
                    }
                    placeholder='Search Helpers'
                    style={{ width: "100%" }}
                    allowClear
                  />
                </Col>
                <Col xs={24} md={12} lg={4} xl={4}>
                  <Space style={{ width: '100%'}}>
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      onClick={getHelperData}
                    >
                      Search
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Card>

      <div >
        <Table
          dataSource={helpers}
          style={{ overflowX: "auto" }}
          columns={helperColumns}
          pagination={false}
          // footer={()=>`List of Helpers - Total Records: ${helpers.length === 0 ? "0" : helpers.length  }`}
          footer={() => {
            const startRecord = (page - 1) * limit + 1;
            const endRecord = Math.min(page * limit, helpers.length ? totalCount : 0);
            return `Showing ${startRecord}-${endRecord} of ${helpers.length ? totalCount : "0"} Records`;
          }}
          scroll={{ x: 'max-content' }}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}

        />
      </div>

      <Flex justify='end' style={{ margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </Flex>

    </DataSheet>
  );
}
